/* eslint-disable max-len */
import { memo } from 'react';

interface IMobileMenuIcon {
  fill: string;
}

function MobileMenuIconNew({ fill }: IMobileMenuIcon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill={fill}
    >
      <path
        d="M15.5 2.89844H0.5V0.398438H15.5V2.89844ZM15.5 10.8984H0.5V13.3984H15.5V10.8984ZM15.5 5.64844H0.5V8.14844H15.5V5.64844Z"
        fill="white"
      />
    </svg>
  );
}

export default memo(MobileMenuIconNew);
